
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'Reference',
  mixins: [staticBlockMixin],
  props: {
    imageReverse: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
